import {
  BlockStyle,
  ComponentType,
  EAppSupportType,
  IComponent,
  IComponentDto,
  IComponentSet,
  IComponentSetDto,
  IFillStyle,
  IRendererNames,
  IStylingBorder,
  IStylingPosition,
  IStylingShadow,
  IStylingTypography
} from "@kuika/kuika-cl-model";
import { Form } from "antd/es";
import _ from "lodash";
import React from "react";
import { ComponentService } from "../../../../services/component-service";
import { ComponentSetService } from "../../../../services/component-set-service";
import { DefaultStyleService } from "../../../../services/default-style-service";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaComponentIcon from "../../../ui-kit/kuika-component-icon/kuika-component-icon";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaSwitch from "../../../ui-kit/kuika-switch/kuika-switch";
import KuikaTooltip from "../../../ui-kit/kuika-tooltip/kuika-tooltip";
import KuikaSmallBoldText from "../../../ui-kit/typography/SmallBoldText/SmallBoldText";
import KuikaSmallText from "../../../ui-kit/typography/SmallText/SmallText";
import { ComponentCategoryList } from "./component-category-list";
import "./component-def-firs-step.scss";

import { StylingVisibilityModal } from "./styling-visibility-settings";
interface ComponentIconChoice {
  name: string;
  url: string;
}

/**
 * The component-list icons a component may be shown with. The value persisted in
 * `icon` is the NAME, not the url — keep the names byte-identical.
 */
const COMPONENT_ICON_CHOICES: ComponentIconChoice[] = [
  { name: "Auto Complate", url: "/images/componentIcons/auto-complate-32.svg" },
  { name: "Badge", url: "/images/componentIcons/badge-32.svg" },
  { name: "Barcode Renderer", url: "/images/componentIcons/barcode-renderer-32.svg" },
  { name: "Breadcrumb", url: "/images/componentIcons/breadcrumb-32.svg" },
  { name: "Calendar", url: "/images/componentIcons/calendar-32.svg" },
  { name: "Chart Area", url: "/images/componentIcons/chart-area-32.svg" },
  { name: "Chart Bar", url: "/images/componentIcons/chart-bar-32.svg" },
  { name: "Chart Donut", url: "/images/componentIcons/chart-donut-32.svg" },
  { name: "Chart Gauge", url: "/images/componentIcons/chart-gauge-32.svg" },
  { name: "Chart Line", url: "/images/componentIcons/chart-line-32.svg" },
  { name: "Chart Pie", url: "/images/componentIcons/chart-pie-32.svg" },
  { name: "Chart Mixed", url: "/images/componentIcons/chart-mixed-32.svg" },
  { name: "Chart Radar", url: "/images/componentIcons/chart-radar-32.svg" },
  { name: "Chart Radial", url: "/images/componentIcons/chart-radial-32.svg" },
  { name: "Chat", url: "/images/componentIcons/chat-32.svg" },
  { name: "Checkbox", url: "/images/componentIcons/checkbox-32.svg" },
  { name: "Column", url: "/images/componentIcons/column-32.svg" },
  { name: "Color Picker", url: "/images/componentIcons/color-picker-32.svg" },
  { name: "Collapse", url: "/images/componentIcons/collapse-32.svg" },
  { name: "Content Menu", url: "/images/componentIcons/content-menu-32.svg" },
  { name: "Content Menu Panel", url: "/images/componentIcons/content-menu-panel-32.svg" },
  { name: "Content Menu Item", url: "/images/componentIcons/content-menu-item-32.svg" },
  { name: "Countdown", url: "/images/componentIcons/countdown-32.svg" },
  { name: "Countup", url: "/images/componentIcons/countup-32.svg" },
  { name: "Currency", url: "/images/componentIcons/currency-32.svg" },
  { name: "Date Range", url: "/images/componentIcons/date-range-32.svg" },
  { name: "Date Time Range", url: "/images/componentIcons/date-time-range-32.svg" },
  { name: "Default Icon", url: "/images/componentIcons/default-icon-32.svg" },
  { name: "Divider", url: "/images/componentIcons/divider-32.svg" },
  { name: "Email", url: "/images/componentIcons/email-32.svg" },
  { name: "Float Button", url: "/images/componentIcons/float-button-32.svg" },
  { name: "Footer", url: "/images/componentIcons/footer-32.svg" },
  { name: "Form", url: "/images/componentIcons/form-32.svg" },
  { name: "Gallery", url: "/images/componentIcons/gallery-32.svg" },
  { name: "Grid", url: "/images/componentIcons/grid-32.svg" },
  { name: "Header", url: "/images/componentIcons/header-32.svg" },
  { name: "Horizontal Stack", url: "/images/componentIcons/horizontal-stack-32.svg" },
  { name: "Horizontal Grid", url: "/images/componentIcons/horizontal-grid-32.svg" },
  { name: "Icon", url: "/images/componentIcons/icon-32.svg" },
  { name: "Image", url: "/images/componentIcons/image-32.svg" },
  { name: "Image Carousel", url: "/images/componentIcons/image-carousel-32.svg" },
  { name: "Input Numeric", url: "/images/componentIcons/input-numeric-32.svg" },
  { name: "Kanban", url: "/images/componentIcons/kanban-32.svg" },
  { name: "Label", url: "/images/componentIcons/label-32.svg" },
  { name: "Language Selector", url: "/images/componentIcons/language-selector-32.svg" },
  { name: "Location Search", url: "/images/componentIcons/location-search-32.svg" },
  { name: "Location Picker", url: "/images/componentIcons/location-picker-32.svg" },
  { name: "Map Location View", url: "/images/componentIcons/map-location-view-32.svg" },
  { name: "Marquee", url: "/images/componentIcons/marquee-32.svg" },
  { name: "Menu", url: "/images/componentIcons/menu-32.svg" },
  { name: "MDEditor", url: "/images/componentIcons/mdeditor-32.svg" },
  { name: "MDViewer", url: "/images/componentIcons/mdviewer-32.svg" },
  { name: "Micro App", url: "/images/componentIcons/micro-app-32.svg" },
  { name: "Multi Select", url: "/images/componentIcons/multi-select-32.svg" },
  { name: "Month Picker", url: "/images/componentIcons/month-picker-32.svg" },
  { name: "Node Tree", url: "/images/componentIcons/node-tree-32.svg" },
  { name: "Pagination", url: "/images/componentIcons/pagination-32.svg" },
  { name: "PA Interaction Buttons", url: "/images/componentIcons/pa-interaction-buttons-32.svg" },
  { name: "PA Process Viewer", url: "/images/componentIcons/process-automation-32.svg" },
  { name: "Panel", url: "/images/componentIcons/panel-32.svg" },
  { name: "Password", url: "/images/componentIcons/password-32.svg" },
  { name: "Percent", url: "/images/componentIcons/percent-32.svg" },
  { name: "Picker Date", url: "/images/componentIcons/picker-date-32.svg" },
  { name: "Picker Date Time", url: "/images/componentIcons/picker-date-time-32.svg" },
  { name: "Picker Location", url: "/images/componentIcons/picker-location-32.svg" },
  { name: "Picker Time", url: "/images/componentIcons/picker-time-32.svg" },
  { name: "Progress Bar", url: "/images/componentIcons/progress-bar-32.svg" },
  { name: "Progress Circle", url: "/images/componentIcons/progress-circle-32.svg" },
  { name: "QR Renderer", url: "/images/componentIcons/qr-renderer-32.svg" },
  { name: "Radio Group", url: "/images/componentIcons/radio-group-32.svg" },
  { name: "Range", url: "/images/componentIcons/range-32.svg" },
  { name: "Rate", url: "/images/componentIcons/rate-32.svg" },
  { name: "Row", url: "/images/componentIcons/row-32.svg" },
  { name: "Select", url: "/images/componentIcons/select-32.svg" },
  { name: "Signature", url: "/images/componentIcons/signature-32.svg" },
  { name: "Slider", url: "/images/componentIcons/slider-32.svg" },
  { name: "Stepper", url: "/images/componentIcons/stepper-32.svg" },
  { name: "Stopwatch", url: "/images/componentIcons/stopwatch-32.svg" },
  { name: "Table", url: "/images/componentIcons/table-32.svg" },
  { name: "Table Header", url: "/images/componentIcons/table-header-32.svg" },
  { name: "Table Row", url: "/images/componentIcons/table-row-32.svg" },
  { name: "Table Column", url: "/images/componentIcons/table-column-32.svg" },
  { name: "Tabs", url: "/images/componentIcons/tabs-32.svg" },
  { name: "Text Area", url: "/images/componentIcons/text-area-32.svg" },
  { name: "Text Input", url: "/images/componentIcons/text-input-32.svg" },
  { name: "Timeline", url: "/images/componentIcons/timeline-32.svg" },
  { name: "Tree", url: "/images/componentIcons/tree-32.svg" },
  { name: "Toggle Switch", url: "/images/componentIcons/toggle-switch-32.svg" },
  { name: "Tooltip", url: "/images/componentIcons/tooltip-32.svg" },
  { name: "Uploader", url: "/images/componentIcons/uploader-32.svg" },
  { name: "Url", url: "/images/componentIcons/url-32.svg" },
  { name: "Vertical Stack", url: "/images/componentIcons/vertical-stack-32.svg" },
  { name: "Video Player", url: "/images/componentIcons/video-player-32.svg" },
  { name: "Year Picker", url: "/images/componentIcons/year-picker-32.svg" },
  { name: "Web View", url: "/images/componentIcons/webview-32.svg" },
  { name: "Recaptcha", url: "/images/componentIcons/recaptcha.svg" },
  { name: "File Directory", url: "/images/componentIcons/file-directory.svg" },
  { name: "Document Uploader", url: "/images/componentIcons/document-uploader.svg" },
  { name: "Document Editor", url: "/images/componentIcons/document-editor.svg" }
];

interface ComponentToggle {
  key: string;
  label: string;
  description: string;
}

interface ComponentToggleGroup {
  title: string;
  toggles: ComponentToggle[];
}

/**
 * The nine booleans of a component definition. `key` is the persisted field name
 * and is read literally by `component-detail.tsx`'s submit whitelist — never
 * rename one.
 */
const COMPONENT_TOGGLE_GROUPS: ComponentToggleGroup[] = [
  {
    title: "Placement",
    toggles: [
      {
        key: "isItChildItem",
        label: "Is it a child item?",
        description: "Only ever placed inside another component, never dropped on its own."
      },
      {
        key: "isItNavigationComponent",
        label: "Is it a navigation component?",
        description: "Takes part in navigation rather than rendering content."
      },
      {
        key: "isDataRepeater",
        label: "Is it a data repeater?",
        description: "Renders its children once per record of a bound datasource."
      }
    ]
  },
  {
    title: "Designer behaviour",
    toggles: [
      {
        key: "isItHiddenFromComponentList",
        label: "Hide from the component list",
        description: "Stays usable in existing screens but is not offered in the toolbox."
      },
      {
        key: "isRenamingDisabled",
        label: "Disable renaming",
        description: "The designer cannot change this component's friendly name."
      },
      {
        key: "isDeprecated",
        label: "Is deprecated?",
        description: "Kept for existing apps but no longer offered for new work."
      }
    ]
  },
  {
    title: "Form and reporting",
    toggles: [
      {
        key: "hasValidate",
        label: "Has validation?",
        description: "Participates in the screen's form validation."
      },
      {
        key: "wrapWithFormItem",
        label: "Wrap with Form Item",
        description: "Generated markup wraps the component in a Form.Item."
      },
      {
        key: "isReportDesignComponent",
        label: "Is a report design component?",
        description: "Available on the report designer canvas instead of the screen canvas."
      }
    ]
  }
];

interface BlockStyleChoice {
  value: BlockStyle;
  label: string;
}

const BLOCK_STYLE_OPTIONS: BlockStyleChoice[] = [
  { value: BlockStyle.inlineBlock, label: "Inline Block" },
  { value: BlockStyle.block, label: "Block" }
];

interface ComponentTypeChoice {
  value: ComponentType;
  label: string;
}

const COMPONENT_TYPE_OPTIONS: ComponentTypeChoice[] = [
  { value: ComponentType.simple, label: "Standard" },
  { value: ComponentType.itemContainer, label: "Item Container" },
  { value: ComponentType.container, label: "Container" },
  { value: ComponentType.abstractContainer, label: "Abstract Container" },
  { value: ComponentType.responsiveColumn, label: "Responsive Column" },
  { value: ComponentType.responsiveRow, label: "Responsive Row" },
  { value: ComponentType.none, label: "None" },
  { value: ComponentType.abstractItemContainer, label: "Abstract Item Container" },
  { value: ComponentType.noneEditable, label: "None Editable" },
  { value: ComponentType.fixedHeader, label: "Fixed Header" },
  { value: ComponentType.fixedFooter, label: "Fixed Footer" },
  { value: ComponentType.layoutHeader, label: "Layout Header" },
  { value: ComponentType.layoutFooter, label: "Layout Footer" },
  { value: ComponentType.layoutLeft, label: "Layout Left" },
  { value: ComponentType.layoutRight, label: "Layout Right" }
];

interface AppSupportTypeChoice {
  value: EAppSupportType;
  label: string;
}

const APP_SUPPORT_TYPE_OPTIONS: AppSupportTypeChoice[] = [
  { value: EAppSupportType.All, label: "All" },
  { value: EAppSupportType.Web, label: "Web" },
  { value: EAppSupportType.Mobile, label: "Mobile" },
  { value: EAppSupportType.WebAndReactNative, label: "Web + React Native" }
];

export interface IComponentFormFirstStepState {
  componentSetList: IComponentSetDto[];
  tagNames: string[];
  newTagName: string;
  isCategoryListModalActive: boolean;
  defaultStylingTypographyLabels: IStylingTypography[];
  defaultStylingPosition: IStylingPosition[];
  defaultStylingBorder: IStylingBorder[];
  defaultStylingShadow: IStylingShadow[];
  defaultStylingFill: IFillStyle[];
  rendererNames: IRendererNames[];
  isStylingVisibilityModalOpen: boolean;
}

export interface IComponentFormFirstStepProps {
  component: IComponent;
  selectedComponentSetId: string;
  getBlockStyle: any;
  getComponentType: any;
  inVisibleStyles?: string[];
  onCheck?: (checkedKeys: any, info: any) => void;
}

class ComponentFormFirstStep extends React.PureComponent<
  IComponentFormFirstStepProps & IWithContextProp,
  IComponentFormFirstStepState
> {
  constructor(props: IComponentFormFirstStepProps & IWithContextProp) {
    super(props);
    this.state = {
      componentSetList: [],
      tagNames: [],
      newTagName: "",
      isCategoryListModalActive: false,
      defaultStylingTypographyLabels: [],
      defaultStylingPosition: [],
      defaultStylingBorder: [],
      defaultStylingShadow: [],
      defaultStylingFill: [],
      rendererNames: [],
      isStylingVisibilityModalOpen: false
    };
  }

  // UNSAFE_componentWillReceiveProps = (nextProps) => {
  //   if (nextProps && nextProps.component && nextProps.component.componentSetId) {
  //     this.loadAllComponentsByComponentSetId();
  //   }
  // };

  async loadAllComponentSets() {
    try {
      const response = await ComponentSetService.Get("4bd34537-525c-4a7c-dde0-08d911312c71");
      if (response.status === 200) {
        const componentSets = [] as IComponentSetDto[];
        componentSets.push(response.data);
        this.setState({ componentSetList: componentSets });
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  async loadAllRenderers() {
    try {
      const response = await ComponentService.GetAllRenderers();
      if (response.status === 200) {
        const componentSets = response.data as IRendererNames[];
        this.setState({ rendererNames: componentSets });
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  async loadDefaultStyles() {
    try {
      const [typographyStyles, positionStyles, borderStyles, shadowStyles, fillStyles] = await Promise.all([
        DefaultStyleService.getDefaultTypographyStyles(),
        DefaultStyleService.getDefaultPositionStyles(),
        DefaultStyleService.getDefaultBorderStyles(),
        DefaultStyleService.getDefaultShadowStyles(),
        DefaultStyleService.getDefaultFillStyles()
      ]);

      this.setState({
        defaultStylingTypographyLabels: typographyStyles as IStylingTypography[],
        defaultStylingPosition: positionStyles as IStylingPosition[],
        defaultStylingBorder: borderStyles as IStylingBorder[],
        defaultStylingShadow: shadowStyles as IStylingShadow[],
        defaultStylingFill: fillStyles as IFillStyle[]
      });
    } catch (error: any) {
      console.error("Failed to load default styles:", error);
      KMainFunctions.exceptionHandler(error);
    }
  }

  // handleComponentSetChange = (componentSetId) => {
  //   this.loadAllComponentsByComponentSetId(componentSetId);
  // };

  async loadAllComponentsByComponentSetId() {
    try {
      const response = await ComponentService.GetAllByComponentSetId(this.props.selectedComponentSetId);
      const tagNames: string[] = [];
      if (response.status === 200) {
        const components = response.data as IComponentDto[];
        components.forEach((c) => {
          const jsonObj = JSON.parse(c.json) as IComponent;
          if (jsonObj && jsonObj.tagName && jsonObj.tagName !== "") {
            if (tagNames.indexOf(jsonObj.tagName) === -1) {
              tagNames.push(jsonObj.tagName);
            }
          }
        });
      }
      if (tagNames.length > 0) {
        this.setState({ tagNames });
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  addTagName = () => {
    const { tagNames, newTagName } = this.state;
    if (newTagName === "" || newTagName === null) {
      KMainFunctions.displayWarningNotification("Please write a tag name.", {
        title: "Tag name is empty!"
      });
    } else if (tagNames.indexOf(newTagName) > -1) {
      KMainFunctions.displayWarningNotification("Please change your tag name.", {
        title: "This tag name is already taken!"
      });
    } else {
      this.setState({
        tagNames: [...tagNames, newTagName || `New item `],
        newTagName: ""
      });
    }
  };

  onTagNameChange = (event) => {
    const value = event.target.value.replace(/[^A-Za-z-]/gi, "");
    this.setState({
      newTagName: value
    });
  };

  componentDidMount() {
    this.loadAllComponentSets();
    this.loadAllComponentsByComponentSetId();
    this.loadAllRenderers();
    this.loadDefaultStyles();
  }

  openCategoryListModal = (e) => {
    e.stopPropagation();
    this.setState({ isCategoryListModalActive: true });
  };

  closeComponentCategoryModal = () => {
    this.setState({ isCategoryListModalActive: false });
  };

  handleCategoryListUpdated = async (bool: boolean) => {
    if (bool === true) {
      this.loadAllComponentSets();
    }
  };

  getCategoryList = () => {
    if (!this.state.componentSetList || this.state.componentSetList.length === 0) {
      return [];
    }
    const componentSetList = _.cloneDeep(this.state.componentSetList);
    const componentSet = componentSetList.filter((c) => c.id === this.props.selectedComponentSetId)[0];
    const readyToParse = componentSet?.json;
    if (readyToParse !== undefined) {
      const parsedJSON = JSON.parse(componentSet?.json) as IComponentSet;
      return parsedJSON.categoryList;
    }
    return [];
  };

  setIcon = (icon: string) => {
    if (icon === "General") {
      return <KuikaComponentIcon src="/images/componentIcons/general-32.svg" width={20} height={20} />;
    }
    if (icon === "Feedback") {
      return <KuikaComponentIcon src="/images/componentIcons/feedback-32.svg" width={20} height={20} />;
    }
    if (icon === "DataInput") {
      return <KuikaComponentIcon src="/images/componentIcons/data-input-32.svg" width={20} height={20} />;
    }
    if (icon === "DataDisplay") {
      return <KuikaComponentIcon src="/images/componentIcons/data-display-32.svg" width={20} height={20} />;
    }
    if (icon === "Layout") {
      return <KuikaComponentIcon src="/images/componentIcons/layout-32.svg" width={20} height={20} />;
    }
    if (icon === "Navigation") {
      return <KuikaComponentIcon src="/images/componentIcons/navigation-32.svg" width={20} height={20} />;
    }
    if (icon === "Other") {
      return <KuikaComponentIcon src="/images/componentIcons/other-32.svg" width={20} height={20} />;
    }
    if (icon === "Tag") {
      return <KuikaComponentIcon src="/images/componentIcons/tag-32.svg" width={20} height={20} />;
    }
    if (icon === "Grid") {
      return <KuikaComponentIcon src="/images/componentIcons/grid-32.svg" width={20} height={20} />;
    }
    if (icon === "Tabs") {
      return <KuikaComponentIcon src="/images/componentIcons/tabs-32.svg" width={20} height={20} />;
    }
    if (icon === "Text") {
      return <KuikaComponentIcon src="/images/componentIcons/text-32.svg" width={20} height={20} />;
    }
    if (icon === "Badge") {
      return <KuikaComponentIcon src="/images/componentIcons/badge-32.svg" width={20} height={20} />;
    }
    if (icon === "Breadcrumb") {
      return <KuikaComponentIcon src="/images/componentIcons/breadcrumb-32.svg" width={20} height={20} />;
    }
    if (icon === "Table") {
      return <KuikaComponentIcon src="/images/componentIcons/table-32.svg" width={20} height={20} />;
    }
    if (icon === "Button") {
      return <KuikaComponentIcon src="/images/componentIcons/button-32.svg" width={20} height={20} />;
    }
    if (icon === "Drawer") {
      return <KuikaComponentIcon src="/images/componentIcons/drawer-32.svg" width={20} height={20} />;
    }
    if (icon === "Gallery") {
      return <KuikaComponentIcon src="/images/componentIcons/gallery-32.svg" width={20} height={20} />;
    }
    if (icon === "Calendar") {
      return <KuikaComponentIcon src="/images/componentIcons/calendar-32.svg" width={20} height={20} />;
    }
    if (icon === "Checkbox") {
      return <KuikaComponentIcon src="/images/componentIcons/checkbox-32.svg" width={20} height={20} />;
    }
    if (icon === "Uploader") {
      return <KuikaComponentIcon src="/images/componentIcons/uploader-32.svg" width={20} height={20} />;
    }
    if (icon === "Accordion") {
      return <KuikaComponentIcon src="/images/componentIcons/accordion-32.svg" width={20} height={20} />;
    }
    if (icon === "CardView") {
      return <KuikaComponentIcon src="/images/componentIcons/card-view-32.svg" width={20} height={20} />;
    }
    if (icon === "ChartBar") {
      return <KuikaComponentIcon src="/images/componentIcons/chart-bar-32.svg" width={20} height={20} />;
    }
    if (icon === "TextLine") {
      return <KuikaComponentIcon src="/images/componentIcons/text-line-32.svg" width={20} height={20} />;
    }
    if (icon === "Downloader") {
      return <KuikaComponentIcon src="/images/componentIcons/downloader-32.svg" width={20} height={20} />;
    }
    if (icon === "ImageView") {
      return <KuikaComponentIcon src="/images/componentIcons/image-view-32.svg" width={20} height={20} />;
    }
    if (icon === "Pagination") {
      return <KuikaComponentIcon src="/images/componentIcons/pagination-32.svg" width={20} height={20} />;
    }
    if (icon === "Description") {
      return <KuikaComponentIcon src="/images/componentIcons/description-32.svg" width={20} height={20} />;
    }
    if (icon === "Notification") {
      return <KuikaComponentIcon src="/images/componentIcons/notification-32.svg" width={20} height={20} />;
    }
    if (icon === "RadioButton") {
      return <KuikaComponentIcon src="/images/componentIcons/radio-button-32.svg" width={20} height={20} />;
    }
    if (icon === "InputNumeric") {
      return <KuikaComponentIcon src="/images/componentIcons/input-numeric-32.svg" width={20} height={20} />;
    }
    if (icon === "MenuHamburger") {
      return <KuikaComponentIcon src="/images/componentIcons/menu-hamburger-32.svg" width={20} height={20} />;
    }
    if (icon === "PickerDateTime") {
      return <KuikaComponentIcon src="/images/componentIcons/picker-date-time-32.svg" width={20} height={20} />;
    }
    if (icon === "MultiSelect") {
      return <KuikaComponentIcon src="/images/componentIcons/multi-select-32.svg" width={20} height={20} />;
    }
    if (icon === "ComboBox") {
      return <KuikaComponentIcon src="/images/componentIcons/combobox-32.svg" width={20} height={20} />;
    }
    if (icon === "FloatButton") {
      return <KuikaComponentIcon src="/images/componentIcons/float-button-32.svg" width={20} height={20} />;
    }

    return "";
  };

  handleBlockStyleSelect = (e: any) => {
    if (e === BlockStyle.inlineBlock || e === BlockStyle.block) {
      this.props.getBlockStyle(e);
    }
  };

  handleComponentTypeSelect = (e: any) => {
    if (
      e === ComponentType.simple ||
      e === ComponentType.itemContainer ||
      e === ComponentType.abstractItemContainer ||
      e === ComponentType.container ||
      e === ComponentType.abstractContainer ||
      e === ComponentType.responsiveColumn ||
      e === ComponentType.responsiveRow
    ) {
      this.props.getComponentType(e);
    }
  };

  renderHint = (message: string): React.ReactNode => {
    return (
      <KuikaTooltip content={message}>
        <span className="kuika-component-form__hint">
          <KuikaSvg name="info-circle" width={14} height={14} color="var(--dark-6)" />
        </span>
      </KuikaTooltip>
    );
  };

  renderField = (label: string, control: React.ReactNode, hint?: string, wide?: boolean): React.ReactNode => {
    return (
      <Form.Item
        className={`kuika-component-form__field${wide ? " kuika-component-form__field--wide" : ""}`}
        label={
          hint ? (
            <span className="kuika-component-form__label">
              {label}
              {this.renderHint(hint)}
            </span>
          ) : (
            label
          )
        }
      >
        {control}
      </Form.Item>
    );
  };

  getTagNameOptions = (): KuikaSelectboxOption[] => {
    return this.state.tagNames.map((tag: string): KuikaSelectboxOption => ({ value: tag, label: tag }));
  };

  getRendererOptions = (): KuikaSelectboxOption[] => {
    return this.state.rendererNames.map((renderer: IRendererNames): KuikaSelectboxOption => ({
      value: renderer.value,
      label: renderer.key
    }));
  };

  getCategoryOptions = (): KuikaSelectboxOption[] => {
    return (this.getCategoryList() ?? []).map((category): KuikaSelectboxOption => ({
      value: category.categoryName,
      searchLabel: category.categoryName,
      label: (
        <span className="kuika-component-form__option">
          {this.setIcon(category.icon)}
          {category.categoryName}
        </span>
      )
    }));
  };

  getIconChoiceOptions = (): KuikaSelectboxOption[] => {
    return COMPONENT_ICON_CHOICES.map((icon: ComponentIconChoice): KuikaSelectboxOption => ({
      value: icon.name,
      searchLabel: icon.name,
      label: (
        <span className="kuika-component-form__option">
          <KuikaComponentIcon className="kuika-component-form__option-icon" src={icon.url} width={20} height={20} />
          {icon.name}
        </span>
      )
    }));
  };

  getStylingOptions = (
    entries: IStylingTypography[] | IStylingPosition[] | IStylingBorder[] | IStylingShadow[] | IFillStyle[],
    idKey: string
  ): KuikaSelectboxOption[] => {
    return (entries as unknown as Record<string, string>[])
      .filter((entry) => Boolean(entry[idKey]))
      .map((entry): KuikaSelectboxOption => ({
        // The persisted value is the UPPERCASED id — `defaultStyleIdsStringToArray`
        // uppercases what it reads back, so a lowercase option never re-selects.
        value: entry[idKey].toUpperCase(),
        label: entry.name
      }));
  };

  renderTagNameDropdownFooter = (): React.ReactNode => {
    return (
      <div className="kuika-component-form__tag-adder">
        <KuikaInput
          data-testid="componentTagNameNewInput"
          placeholder="New tag name"
          value={this.state.newTagName}
          onChange={(e) => this.onTagNameChange(e)}
        />
        <KuikaButton data-testid="componentTagNameAddButton" type="secondary" onClick={this.addTagName}>
          Add
        </KuikaButton>
      </div>
    );
  };

  render() {
    return (
      <>
        {this.state.isStylingVisibilityModalOpen && (
          <StylingVisibilityModal
            showModal={this.state.isStylingVisibilityModalOpen}
            closeModal={() => this.setState({ isStylingVisibilityModalOpen: false })}
            editingComponent={this.props.component}
            checkedKeys={this.props.inVisibleStyles}
            onCheck={this.props.onCheck}
          />
        )}
        <ComponentCategoryList
          selectedComponentSetId={this.props.selectedComponentSetId}
          showModal={this.state.isCategoryListModalActive}
          closeModal={this.closeComponentCategoryModal}
          component={this.props.component}
          onCategoryListUpdated={this.handleCategoryListUpdated}
        />

        <div className="kuika-component-form" data-testid="componentMainInformationStep">
          <section className="kuika-component-form__section">
            <KuikaSmallBoldText className="kuika-component-form__section-title">Identity</KuikaSmallBoldText>
            <div className="kuika-component-form__grid">
              <Form.Item
                className="kuika-component-form__field"
                label="Display Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter a component name" },
                  { max: 250, message: "Component name cannot be longer than 250 characters" }
                ]}
              >
                <KuikaInput data-testid="componentDisplayNameInput" placeholder="ex: DataTable, PriceLabel" />
              </Form.Item>

              {this.renderField(
                "Tag Name",
                <Form.Item name="tagName" noStyle>
                  <KuikaSelectbox
                    data-testid="componentTagNameSelect"
                    searchable
                    placeholder="Please select a tag name"
                    options={this.getTagNameOptions()}
                    dropdownFooter={this.renderTagNameDropdownFooter()}
                  />
                </Form.Item>,
                "The tag this component is emitted as in the component library."
              )}

              {this.renderField(
                "Renderer Name",
                <Form.Item name="renderer" noStyle>
                  <KuikaSelectbox
                    data-testid="componentRendererSelect"
                    searchable
                    allowClear
                    placeholder="Please select a renderer name"
                    options={this.getRendererOptions()}
                  />
                </Form.Item>,
                "The renderer that draws this component on the canvas."
              )}

              {!this.props.component.isItChildItem && !this.props.component.isItNavigationComponent && (
                <Form.Item
                  className="kuika-component-form__field"
                  label={
                    <span className="kuika-component-form__label">
                      Component Category
                      <KuikaButton
                        data-testid="componentCategoryManageButton"
                        type="text"
                        size="sm"
                        onClick={(e) => this.openCategoryListModal(e)}
                      >
                        Manage
                      </KuikaButton>
                    </span>
                  }
                >
                  <Form.Item name="componentCategory" noStyle>
                    <KuikaSelectbox
                      data-testid="componentCategorySelect"
                      searchable
                      allowClear
                      placeholder="Select component category"
                      options={this.getCategoryOptions()}
                    />
                  </Form.Item>
                </Form.Item>
              )}

              {this.renderField(
                "Title Attribute Name",
                <Form.Item name="titleAttributeName" noStyle>
                  <KuikaInput
                    data-testid="componentTitleAttributeInput"
                    placeholder="Enter an attribute name for title"
                  />
                </Form.Item>,
                "If the component has a string title property, name it here."
              )}

              {this.renderField(
                "Icon",
                <Form.Item name="icon" noStyle>
                  <KuikaSelectbox
                    data-testid="componentIconSelect"
                    searchable
                    placeholder="Select an icon"
                    options={this.getIconChoiceOptions()}
                  />
                </Form.Item>,
                "Shown next to the component in the toolbox."
              )}
            </div>
          </section>

          <section className="kuika-component-form__section">
            <KuikaSmallBoldText className="kuika-component-form__section-title">Rendering</KuikaSmallBoldText>
            <div className="kuika-component-form__grid">
              <Form.Item
                className="kuika-component-form__field"
                label="Block Style"
                name="blockStyle"
                rules={[{ required: true, message: "Please select a block style of component" }]}
              >
                <KuikaSelectbox
                  data-testid="componentBlockStyleSelect"
                  searchable
                  placeholder="Select block style of component"
                  options={BLOCK_STYLE_OPTIONS.map((choice: BlockStyleChoice): KuikaSelectboxOption => ({
                    value: choice.value,
                    label: choice.label
                  }))}
                  onChange={(value) => this.handleBlockStyleSelect(value)}
                />
              </Form.Item>

              <Form.Item
                className="kuika-component-form__field"
                label="Component Type"
                name="componentType"
                rules={[{ required: true, message: "Please select a component type" }]}
              >
                <KuikaSelectbox
                  data-testid="componentTypeSelect"
                  searchable
                  placeholder="Select component type of component"
                  options={COMPONENT_TYPE_OPTIONS.map((choice: ComponentTypeChoice): KuikaSelectboxOption => ({
                    value: choice.value,
                    label: choice.label
                  }))}
                  onChange={(value) => this.handleComponentTypeSelect(value)}
                />
              </Form.Item>

              {this.renderField(
                "App Support Type",
                <Form.Item name="appSupportType" noStyle>
                  <KuikaSelectbox
                    data-testid="componentAppSupportTypeSelect"
                    searchable
                    placeholder="Please select a support type"
                    options={APP_SUPPORT_TYPE_OPTIONS.map((choice: AppSupportTypeChoice): KuikaSelectboxOption => ({
                      value: choice.value,
                      label: choice.label
                    }))}
                  />
                </Form.Item>,
                "Which targets this component may be placed on."
              )}

              {this.renderField(
                "Drag Drop Area Text",
                <Form.Item name="dragDropAreaText" noStyle>
                  <KuikaInput data-testid="componentDragDropAreaTextInput" placeholder="Enter drag drop area text" />
                </Form.Item>,
                "Placeholder shown inside an empty container on the canvas."
              )}
            </div>
          </section>

          <section className="kuika-component-form__section">
            <div className="kuika-component-form__section-head">
              <KuikaSmallBoldText className="kuika-component-form__section-title">Default styling</KuikaSmallBoldText>
              <KuikaButton
                data-testid="componentHideStylingButton"
                type="secondary"
                size="sm"
                onClick={() => this.setState({ isStylingVisibilityModalOpen: true })}
              >
                Hide specific styling
              </KuikaButton>
            </div>
            <KuikaSmallText className="kuika-component-form__section-caption">
              Applied to every new instance of this component.
            </KuikaSmallText>
            <div className="kuika-component-form__grid">
              {this.renderField(
                "Typography",
                <Form.Item name="defaultStylingTypography" noStyle>
                  <KuikaSelectbox
                    data-testid="componentDefaultTypographySelect"
                    mode="multiple"
                    searchable
                    allowClear
                    placeholder="Please select a typography name"
                    options={this.getStylingOptions(this.state.defaultStylingTypographyLabels, "typoId")}
                  />
                </Form.Item>
              )}
              {this.renderField(
                "Position",
                <Form.Item name="defaultStylingPosition" noStyle>
                  <KuikaSelectbox
                    data-testid="componentDefaultPositionSelect"
                    mode="multiple"
                    searchable
                    allowClear
                    placeholder="Please select a position name"
                    options={this.getStylingOptions(this.state.defaultStylingPosition, "positionId")}
                  />
                </Form.Item>
              )}
              {this.renderField(
                "Border",
                <Form.Item name="defaultStylingBorder" noStyle>
                  <KuikaSelectbox
                    data-testid="componentDefaultBorderSelect"
                    mode="multiple"
                    searchable
                    allowClear
                    placeholder="Please select a border name"
                    options={this.getStylingOptions(this.state.defaultStylingBorder, "borderId")}
                  />
                </Form.Item>
              )}
              {this.renderField(
                "Shadow",
                <Form.Item name="defaultStylingShadow" noStyle>
                  <KuikaSelectbox
                    data-testid="componentDefaultShadowSelect"
                    mode="multiple"
                    searchable
                    allowClear
                    placeholder="Please select a shadow name"
                    options={this.getStylingOptions(this.state.defaultStylingShadow, "shadowId")}
                  />
                </Form.Item>
              )}
              {this.renderField(
                "Fill",
                <Form.Item name="defaultStylingFill" noStyle>
                  <KuikaSelectbox
                    data-testid="componentDefaultFillSelect"
                    mode="multiple"
                    searchable
                    allowClear
                    placeholder="Please select a fill name"
                    options={this.getStylingOptions(this.state.defaultStylingFill, "fillId")}
                  />
                </Form.Item>
              )}
            </div>
          </section>

          <div className="kuika-component-form__toggle-groups">
            {COMPONENT_TOGGLE_GROUPS.map((group: ComponentToggleGroup) => (
              <section className="kuika-component-form__section" key={group.title}>
                <KuikaSmallBoldText className="kuika-component-form__section-title">{group.title}</KuikaSmallBoldText>
                {group.toggles.map((toggle: ComponentToggle) => (
                  <div className="kuika-component-form__toggle" key={toggle.key}>
                    <div className="kuika-component-form__toggle-text">
                      <KuikaSmallText>{toggle.label}</KuikaSmallText>
                      <KuikaSmallText className="kuika-component-form__toggle-description">
                        {toggle.description}
                      </KuikaSmallText>
                    </div>
                    <Form.Item name={toggle.key} valuePropName="checked" noStyle>
                      <KuikaSwitch
                        dataTestId={`component${toggle.key.charAt(0).toUpperCase()}${toggle.key.slice(1)}Switch`}
                        labelPosition="none"
                      />
                    </Form.Item>
                  </div>
                ))}
              </section>
            ))}
          </div>
        </div>
      </>
    );
  }
}

const componentFormFirstStep = withContext<IComponentFormFirstStepProps>(ComponentFormFirstStep);
export { componentFormFirstStep as ComponentFormFirstStep };
